<template>
  <section class="p-0">
    <div
      v-if="loading"
      style="min-width: 800px; min-height: 200px"
      class="d-flex flex-column justify-content-center align-items-center"
    >
      <h5 class="text-center mb-3">
        Cargando Pagos... Espere Por favor
      </h5>
      <v-progress-circular
        :loading="loading"
        size="55"
        indeterminate
        color="primary"
        class="mx-auto text-center"
      />
    </div>
    <v-data-table
      v-else
      :headers="headers"
      :items="pendingPayments"
      class="p-0"
      style="width: 800px !important;"
      hide-default-footer
    >
      <template v-slot:item.code="{ item }">
        <div class="d-flex align-items-center justify-content-end">
          <v-chip class="primary">
            {{ item.code }}
          </v-chip>
        </div>
      </template>
      <template v-slot:item.tax_date="{ item }">
        <span v-if="item.tax_date != null">{{
          formatDateToHuman(item.tax_date)
        }}</span>
      </template>
      <template v-slot:item.due_date="{ item }">
        <span v-if="item.due_date != null">{{
          formatDateToHuman(item.due_date)
        }}</span>
      </template>
      <template v-slot:item.amount="{ item }">
        <div class="text-right">
          {{
            item.total
              ? `$ ${item.total.toLocaleString("cl-CL", {
                  currency: "CLP",
                })}`
              : item.virtual_post_payment
              ? `$ ${item.virtual_post_payment.amount.toLocaleString("cl-CL", {
                  currency: "CLP",
                })}`
              : "-"
          }}
        </div>
      </template>
      <template v-slot:item.business_name="{ item }">
        <div class="text-left">
          {{ item.name }}
        </div>
      </template>
      <template v-slot:item.rut="{ item }">
        <div class="text-right">
          {{ item.rut }}
        </div>
      </template>
    </v-data-table>
  </section>
</template>

<script>
import { formatDateMomentToHumanAndAddDay } from "@/helpers/common";
export default {
  props: {
    project_code: {
      type: String,
      required: true,
    },
    project: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      headers: [
        {
          text: "N° de Factura",
          align: "start",
          sortable: false,
          value: "folio_number",
        },
        { text: "Fecha", value: "tax_date", align: "center", sortable: false },
        {
          text: "Fecha Vencimiento",
          value: "due_date",
          align: "center",
          sortable: false,
        },
        {
          text: "Monto",
          value: "amount",
          align: "end",
          sortable: false,
          width: "12%",
        },
        {
          text: "RUT",
          value: "rut",
          align: "end",
          sortable: false,
          width: "15%",
        },
        {
          text: "Razón Social",
          value: "business_name",
          align: "start",
          sortable: false,
        },
      ],
      pendingPayments: [],
    };
  },
  mounted() {
    this.getPendingPaymentsFromProject(this.project_code);
  },
  methods: {
    formatDateToHuman(date) {
      return formatDateMomentToHumanAndAddDay(date);
    },
    async getPendingPaymentsFromProject() {
      this.loading = true;
      let self = this;
      setTimeout(function() {
        self.pendingPayments = self.project.invoices;
        self.loading = false;
      }, 1000);
    },
  },
};
</script>

<style></style>
